import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_3 = { class: "card-body border-top p-9" }
const _hoisted_4 = { class: "row mb-6" }
const _hoisted_5 = { class: "col-lg-6 fv-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tim Area", -1)
const _hoisted_7 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Keterangan", -1)
const _hoisted_11 = { class: "card-body py-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-lg-12 col-form-label fw-bold py-0",
  style: {"font-size":"16px"}
}, "Sales Member", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-lg-12 col-form-label pt-0 pb-3",
  style: {"font-size":"12px","color":"#B7B7B7"}
}, "Manajemen Data Member ", -1)
const _hoisted_14 = {
  style: {"padding-left":"0px!important"},
  class: "card-footer d-flex justify-content-start py-6 pl-0 pr-9"
}
const _hoisted_15 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_1"
}
const _hoisted_16 = { class: "modal-dialog" }
const _hoisted_17 = { class: "modal-content" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Tambah Area"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_19 = { class: "modal-body" }
const _hoisted_20 = { class: "col-xl-12" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Provinsi", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Provinsi", -1)
const _hoisted_23 = ["label", "value"]
const _hoisted_24 = { class: "modal-footer" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_26 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_2"
}
const _hoisted_27 = { class: "modal-dialog" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Tambah Sales"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_30 = { class: "modal-body" }
const _hoisted_31 = { class: "col-xl-12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Sales Area", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sales Area", -1)
const _hoisted_34 = ["label", "value"]
const _hoisted_35 = { class: "modal-footer" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_37 = { class: "col-lg-12" }
const _hoisted_38 = { class: "table-responsive" }
const _hoisted_39 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"23%"},
      class: "text-center"
    }, "Nama Sales"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"10%"},
      class: "text-center"
    }, "Jumlah Sekolah"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "text-center"
    }, "Pendapatan Terbayar"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "text-center"
    }, "Pendapatan Belum Terbayar"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "text-center"
    }, "Total Pendapatan"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"7%"},
      class: "text-center"
    }, "Aksi")
  ])
], -1)
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "text-left" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = { class: "text-center" }
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = { class: "text-center" }
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("th", {
  style: {"width":"23%"},
  class: "text-center"
}, "Jumlah", -1)
const _hoisted_54 = {
  style: {"width":"10%"},
  class: "text-center"
}
const _hoisted_55 = {
  style: {"width":"20%"},
  class: "text-center"
}
const _hoisted_56 = {
  style: {"width":"20%"},
  class: "text-center"
}
const _hoisted_57 = {
  style: {"width":"20%"},
  class: "text-center"
}
const _hoisted_58 = { key: 2 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = {
  key: 3,
  class: "fv-plugins-message-container"
}
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_delete"
}
const _hoisted_64 = { class: "modal-dialog" }
const _hoisted_65 = { class: "modal-content" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Hapus Sales"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_67 = { class: "modal-body" }
const _hoisted_68 = { class: "col-xl-12" }
const _hoisted_69 = { style: {"font-weight":"normal"} }
const _hoisted_70 = { class: "modal-footer" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_72 = { class: "card-body py-3" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-lg-12 col-form-label fw-bold py-0",
  style: {"font-size":"16px"}
}, "Wilayah Sales Area", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-lg-12 col-form-label pt-0 pb-3",
  style: {"font-size":"12px","color":"#B7B7B7"}
}, "Manajemen Data Wilayah ", -1)
const _hoisted_75 = { class: "table-responsive" }
const _hoisted_76 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"20%"},
      class: "text-center"
    }, "Provinsi"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"15%"},
      class: "text-center"
    }, "Sekolah"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"12%"},
      class: "text-center"
    }, "Leads"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"12%"},
      class: "text-center"
    }, "Proses"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"12%"},
      class: "text-center"
    }, "Closing"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"10%"},
      class: "text-center"
    }, "Live "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"12%"},
      class: "text-center"
    }, "Cancel "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"7%"},
      class: "text-center"
    }, "Aksi ")
  ])
], -1)
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { class: "text-center" }
const _hoisted_80 = { class: "text-center" }
const _hoisted_81 = { class: "text-center" }
const _hoisted_82 = { class: "text-center" }
const _hoisted_83 = { class: "text-center" }
const _hoisted_84 = { class: "text-center" }
const _hoisted_85 = { class: "text-center" }
const _hoisted_86 = { class: "text-center" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = { key: 1 }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = {
  key: 2,
  class: "fv-plugins-message-container"
}
const _hoisted_94 = { class: "fv-help-block" }
const _hoisted_95 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_delete_area"
}
const _hoisted_96 = { class: "modal-dialog" }
const _hoisted_97 = { class: "modal-content" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Hapus Area"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_99 = { class: "modal-body" }
const _hoisted_100 = { class: "col-xl-12" }
const _hoisted_101 = { style: {"font-weight":"normal"} }
const _hoisted_102 = { class: "modal-footer" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_104 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_108 = [
  _hoisted_106,
  _hoisted_107
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        id: "kt_account_profile_details_form",
        class: "form",
        novalidate: "novalidate",
        onSubmit: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveChanges1()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "name",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Tim Area",
                  modelValue: _ctx.edit.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.edit.name) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.edit.name == '' )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.items.errorName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "note",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Keterangan",
                  modelValue: _ctx.edit.note,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.edit.note) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-warning me-3",
                type: "button",
                "data-bs-toggle": "modal",
                "data-bs-target": "#kt_modal_1",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addAreaModal()))
              }, " Tambah Area "),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_Field, {
                          as: "select",
                          class: "form-select form-select-lg fw-bold",
                          name: "regions",
                          autocomplete: "off",
                          modelValue: _ctx.items.regions,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.items.regions) = $event))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.provinsiOptions, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option.id,
                                label: option.name,
                                value: option.name
                              }, null, 8, _hoisted_23))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitAddProvince())),
                        "data-bs-dismiss": "modal"
                      }, " Simpan ")
                    ])
                  ])
                ])
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary me-3",
                type: "button",
                "data-bs-toggle": "modal",
                "data-bs-target": "#kt_modal_2",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addSalesModal()))
              }, " Tambah Sales "),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_Field, {
                          as: "select",
                          class: "form-select form-select-lg fw-bold",
                          name: "member",
                          autocomplete: "off",
                          modelValue: _ctx.items.members,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.items.members) = $event))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_33,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.user_sales_area, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option._id,
                                label: option.name,
                                value: option._id
                              }, null, 8, _hoisted_34))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitAddSales())),
                        "data-bs-dismiss": "modal"
                      }, " Simpan ")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                class: "btn me-3 border rounded-lg mb-2",
                style: {"background-color":"#FFFFFF"},
                type: "button",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.ShowFilter && _ctx.ShowFilter(...args)))
              }, " Filter ")
            ]),
            (_ctx.edit.showFilter == true)
              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  class: "mb-2 col-lg-4",
                  "picker-options": _ctx.pickerOptions,
                  modelValue: _ctx.edit.dateAll,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.edit.dateAll) = $event)),
                  type: "monthrange",
                  "start-placeholder": "Bulan Awal",
                  "end-placeholder": "Bulan Akhir",
                  "value-format": "YYYY-MM",
                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pilihTanggalAll()))
                }, null, 8, ["picker-options", "modelValue"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("table", _hoisted_39, [
                _hoisted_40,
                (_ctx.edit.members.length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_41, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.edit.members, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_42, _toDisplayString(item.salesName), 1),
                          _createElementVNode("td", _hoisted_43, _toDisplayString(item.globalSchools), 1),
                          _createElementVNode("td", _hoisted_44, " Rp. " + _toDisplayString(_ctx.formatPrice(item.invoicePaid)), 1),
                          _createElementVNode("td", _hoisted_45, " Rp. " + _toDisplayString(_ctx.formatPrice(item.invoiceUnpaid)), 1),
                          _createElementVNode("td", _hoisted_46, " Rp. " + _toDisplayString(_ctx.formatPrice(item.totalInvoices)), 1),
                          _createElementVNode("td", _hoisted_47, [
                            ( _ctx.edit.leaderId != item.salesId)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "symbol symbol-35px me-2",
                                  title: "Hapus",
                                  style: {"cursor":"pointer"},
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#kt_modal_delete",
                                  onClick: ($event: any) => (_ctx.showModalDelete(item.salesId,item.salesName))
                                }, _hoisted_50, 8, _hoisted_48))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.edit.members.length)
                  ? (_openBlock(), _createElementBlock("thead", _hoisted_51, [
                      _createElementVNode("tr", _hoisted_52, [
                        _hoisted_53,
                        _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.edit.totalSekolah), 1),
                        _createElementVNode("th", _hoisted_55, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.edit.totalPendapatanTerbayar)), 1),
                        _createElementVNode("th", _hoisted_56, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.edit.totalPendapatanBelumTerbayar)), 1),
                        _createElementVNode("th", _hoisted_57, "Rp. " + _toDisplayString(_ctx.formatPrice(_ctx.edit.totalPendapatan)), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_58, _hoisted_60)),
                (!_ctx.edit.members.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.items.errorMember), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _hoisted_66,
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("h5", _hoisted_69, "Apakah yakin akan menghapus " + _toDisplayString(_ctx.dataDelete.salesName) + "?", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleDeleteSales(_ctx.index, _ctx.dataDelete.salesId))),
                        "data-bs-dismiss": "modal"
                      }, " Hapus ")
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _hoisted_74,
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("table", _hoisted_76, [
                _hoisted_77,
                (_ctx.edit.regions.length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_78, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.edit.regions, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_79, _toDisplayString(item.province), 1),
                          _createElementVNode("td", _hoisted_80, _toDisplayString(item.totalSchools), 1),
                          _createElementVNode("td", _hoisted_81, _toDisplayString(item.leads), 1),
                          _createElementVNode("td", _hoisted_82, _toDisplayString(item.process), 1),
                          _createElementVNode("td", _hoisted_83, _toDisplayString(item.closing), 1),
                          _createElementVNode("td", _hoisted_84, _toDisplayString(item.live), 1),
                          _createElementVNode("td", _hoisted_85, _toDisplayString(item.cancel), 1),
                          _createElementVNode("td", _hoisted_86, [
                            _createElementVNode("a", {
                              class: "symbol symbol-35px me-2",
                              title: "Hapus",
                              style: {"cursor":"pointer"},
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_delete_area",
                              onClick: ($event: any) => (_ctx.showModalDeleteArea(item.province))
                            }, _hoisted_89, 8, _hoisted_87)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_90, _hoisted_92)),
                (!_ctx.edit.regions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                      _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.items.errorRegion), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("div", _hoisted_97, [
                    _hoisted_98,
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("h5", _hoisted_101, "Apakah yakin akan menghapus " + _toDisplayString(_ctx.dataDelete.province) + "?", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _hoisted_103,
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-danger",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleDeleteArea(_ctx.index, _ctx.dataDelete.province))),
                        "data-bs-dismiss": "modal"
                      }, " Hapus ")
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("button", {
              class: "btn btn-danger me-3",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$router.push('/superadmin/sales/sales-area/')))
            }, " Batal "),
            _createElementVNode("button", {
              type: "submit",
              id: "kt_account_profile_details_submit",
              ref: "submitButton",
              class: "btn btn-primary",
              disabled: _ctx.items.disableButton
            }, _hoisted_108, 8, _hoisted_105)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}